export default function CareRecipientAccountRegistrationSettings(values) {
  const errors = {};

  return errors;
}
